<!-- <div>{{directoryInfo?.files?.length}}</div>
<div>{{directoryInfo?.folders?.length}}</div> -->

<div>
    <ng-container *ngIf="directoryInfo?.folders.length > 0 || directoryInfo?.files.length > 0">
        <div class="bulk-menu">
            <div class="row">
                <div class="col-md-8">
                    <div class="bulk-actions-container">
                        <div class="dropdown dropdown-select">
                            <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fa" [ngClass]="getSelectedCount() > 0 ? 'fa-regular fa-check-square' : 'fa-regular fa-square'"></i>
                            </button>
                            <div class="dropdown-menu dropdown-menu-start" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" (click)="toggleAllSelection(true)">Select all</a>
                                <a class="dropdown-item" (click)="toggleAllSelection(false)">Unselect all</a>
                                <hr />
                                <a class="dropdown-item" (click)="toggleAllFolderSelection(true)">Select all folders</a>
                                <a class="dropdown-item" (click)="toggleAllFileSelection(true)">Select all files</a>
                            </div>
                        </div>

                        <span class="font-light selected-count">{{getSelectedCount()}} selected</span>
                        <div id="choose-action" class="dropdown dropdown-bulk-actions" placement="top">
                            <button class="btn dropdown-toggle" [disabled]="getSelectedCount() == 0" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span>Choose action</span>
                            </button>
                            <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" (click)="showMoveBulkModal()">
                                    <i class="fa fa-fw fa-arrows padding-right-10" aria-hidden="true"></i> Move
                                </a>
                                <a class="dropdown-item" (click)="onDownloadBulk()" *ngIf="selectedFolderIds?.length == 0">
                                    <i class="fa fa-fw fa-download padding-right-10" aria-hidden="true"></i> Download
                                </a>
                                <a class="dropdown-item" (click)="showAssignComponentsBulkModal()" *ngIf="selectedFolderIds?.length == 0">
                                    <i class="fa fa-fw fa-link padding-right-10" aria-hidden="true"></i> Assign {{ 'components' | terminology | async }}
                                </a>
                                <a *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" class="dropdown-item" (click)="showDeleteBulkModal()">
                                    <i class="fa fa-fw fa-trash-can padding-right-10" aria-hidden="true"></i> Delete
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="text-end text-muted font-light">Displaying  <strong>{{directoryInfo?.files?.length}}</strong> files</div>
                </div>
            </div>
        </div>

        <div class="file-list-container">
            <div class="row grid-header">
                <div class="col-md-6"><span class="margin-left-30">Name</span></div>
                <div class="col-md-3">Uploaded</div>
                <div class="col-md-1">File Size</div>
                <div class="col-md-1">File Count</div>
                <div class="col-md-1"></div>
            </div>
            <ng-container *ngFor="let folder of directoryInfo?.folders">
                <ng-container [ngTemplateOutlet]='folderTemplate' [ngTemplateOutletContext]="{folder:folder}"></ng-container>
            </ng-container>
            <ng-container *ngFor="let file of directoryInfo?.files">
                <ng-container [ngTemplateOutlet]='fileTemplate' [ngTemplateOutletContext]="{file:file}"></ng-container>
            </ng-container>
        </div>
    </ng-container>
</div>

<ng-template #folderTemplate let-folder="folder">
    <div class="row file-item-row" [class.selected]="isFolderSelected(folder)">
        <div class="col-md-6">
            <div *ngIf="!folder.isSystemFolder" class="fa-pull-left select-item" (click)="toggleFolderSelection(folder)">
                <i class="fa" [ngClass]="isFolderSelected(folder) ? 'fa-regular fa-check-square' : 'fa-regular fa-square'"></i>
            </div>
            <div *ngIf="folder.isSystemFolder" class="fa-pull-left select-item system-folder-lock"
                 title="System folders can't be edited or deleted.">
                <i class="fa fa-lock" aria-hidden="true"></i>
            </div>
            <div class="name-container">
                <div (click)="onFolderSelected(folder.folderId)" class="name"><i class="fa fa-folder"></i> {{folder.folderName}}</div>
            </div>
        </div>
        <div class="col-md-3 detail"> - </div>
        <div class="col-md-1 detail"> - </div>
        <div class="col-md-1 detail"><span>{{getFolderCountDisplay(folder)}}</span></div>
        <div class="col-md-1">
            <sp-dropdown hideStyling="true" isButtonToggle="true" isMarginLeft="true">
                <sp-dropdown-item  text="Open Folder" displayIcon="true" iconClass="fa-regular fa-folder-open" (click)="onFolderSelected(folder.folderId)"></sp-dropdown-item>
                <sp-dropdown-item *ngIf="folderRowActionsEnabled(folder)" text="Rename" displayIcon="true" iconClass="fa-pencil-square" (click)="showRenameFolderModal(folder)"></sp-dropdown-item>
                <sp-dropdown-item *ngIf="folderRowActionsEnabled(folder)" text="Move" displayIcon="true" iconClass="fa-arrows" (click)="showMoveFolderModal(folder)"></sp-dropdown-item>
                <ng-container *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']">
                    <sp-dropdown-item *ngIf="folderRowActionsEnabled(folder)" text="Delete" displayIcon="true" iconClass="fa-trash-can" (click)="showDeleteFolderModal(folder)"></sp-dropdown-item>
                </ng-container>
            </sp-dropdown>
        </div>
    </div>
</ng-template>

<ng-template #fileTemplate let-file="file"  >
    <div class="row file-item-row" [class.selected]="isFileSelected(file)">
        <div class="col-md-6">
            <div class="fa-pull-left select-item" (click)="toggleFileSelection(file)">
                <i class="fa" [ngClass]="isFileSelected(file) ? 'fa-regular fa-check-square' : 'fa-regular fa-square'"></i>
            </div>
            <div class="name-container">
                <div class="name" (click)="onDownloadFile(file)">
                    <sp-file-type-icon [contentType]="file.contentType" [fileName]="file.fileName"></sp-file-type-icon>
                    <span>{{file.fileName}}</span>
                </div>
                <div *ngIf="file.propertyComponents?.length > 0"  class="file-component-list">
                    <span>{{ 'Components' | terminology | async }}: </span>
                    <div *ngFor="let component of file?.propertyComponents" class="badge badge-green-light">
                        <a [routerLink]="['/useraccount/components/', component.propertyComponentId]">{{ component.name }}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3 detail">{{file.uploadDate | date }} by {{file.uploadByFullName}} </div>
        <div class="col-md-1 detail">{{file.fileSize | fileSize }}</div>
        <div class="col-md-1 detail">-</div>
        <div class="col-md-1">
            <sp-dropdown hideStyling="true" isButtonToggle="true" isMarginLeft="true">
                <sp-dropdown-item  text="Rename" displayIcon="true" iconClass="fa-pencil-square" (click)="showRenameFileModal(file)"></sp-dropdown-item>
                <sp-dropdown-item  text="Move" displayIcon="true" iconClass="fa-arrows" (click)="showMoveFileModal(file)"></sp-dropdown-item>
                <sp-dropdown-item  text="Download" displayIcon="true" iconClass="fa-download" (click)="onDownloadFile(file)"></sp-dropdown-item>
                <sp-dropdown-item  [text]="'Assign ' + (('Components' | terminology | async) || 'Components')" displayIcon="true" iconClass="fa-pencil-square" (click)="showAssignComponentsModal(file)"></sp-dropdown-item>
                <sp-dropdown-item *spHasRole="['Admin', 'Manager', 'PortfolioAdmin']" text="Delete" displayIcon="true" iconClass="fa-trash-can" (click)="showDeleteFileModal(file)"></sp-dropdown-item>
            </sp-dropdown>
        </div>
    </div>
</ng-template>

<sp-select-folder-modal
    #selectFolder
    [folderStructure]="folderStructure"
    [itemName]="moveItemName"
    [currentFolderId]="directoryInfo?.folderId"
    [excludeFolderIds]="moveExcludeFolderIds"
    (folderSelected)="onFolderSelectedForMove($event)"
></sp-select-folder-modal>

<sp-file-assign-component-modal
    #assignComponents
    [propertyId]="propertyId"
    [fiscalYear]="fiscalYear"
    [files]="assignComponentFiles"
    (onConfirm)="onAssignComponentsConfirm($event)">
</sp-file-assign-component-modal>

<sp-modal title="RENAME FOLDER" (confirm)="onRenameFolder()" confirmButtonText="Rename" #renameFolder>
    <div class="row">
        <div class="col-md-10">
            <input type="text" class="form-control" [(ngModel)]="renameFolderName" placeholder="Folder Name" />
        </div>
    </div>
</sp-modal>

<sp-modal title="DELETE FOLDER" (confirm)="onDeleteFolder()" confirmButtonText="Delete" isWarning="true" #deleteFolder>
    <div>
        Do you want to remove the folder <strong>{{folderForAction?.folderName}}</strong> and all of its contents from your document library?
    </div>
</sp-modal>

<sp-modal title="RENAME FILE" (confirm)="onRenameFile()" confirmButtonText="Rename" #renameFile>
    <div class="row">
        <div class="col-md-10">
            <input type="text" class="form-control" [(ngModel)]="renameFileName" placeholder="File Name" />
        </div>
    </div>
</sp-modal>

<sp-modal title="DELETE FILE" (confirm)="onDeleteFile()" confirmButtonText="Delete" isWarning="true" #deleteFile>
    <div>
        Do you want to remove the file <strong>{{fileForAction?.fileName}}</strong> from your document library?
    </div>
</sp-modal>

<sp-modal title="DELETE SELECTED ITEMS" (confirm)="onDeleteBulk()" confirmButtonText="Delete" isWarning="true" #deleteBulk>
    <div>
        Do you want to remove the <strong>{{getSelectedCount()}} selected items</strong>?
    </div>
</sp-modal>

<!-- <sp-bulk-assign-component-modal
    #bulkAssignPhotos
    [propertyId]="propertyId"
    [fiscalYear]="fiscalYear"
    [selectedPhotoCount]="getSelectedPhotoCount()"
    (onConfirm)="onBulkAssignComponentConfirm($event)">
</sp-bulk-assign-component-modal> -->

<dx-tooltip target="#choose-action" [wrapperAttr]="{ class: 'choose-action-tooltip' }" showEvent="mouseenter"
    hideEvent="mouseleave" position="top" (onShowing)="onPopupShowing($event)">
    <div *dxTemplate="let data = data; of: 'content'">
        <div>
            Select at least one file or folder to activate options
        </div>
    </div>
</dx-tooltip>
